import * as Yup from 'yup';
import { TargetConfigMetaData } from '../models';
import Mixpanel from './index';

export const MIXPANEL_CONFIG: TargetConfigMetaData = {
  formComponent: Mixpanel,

  initialValues: {
    projectId: '',
    projectToken: '',
    serviceAccountUsername: '',
    serviceAccountSecret: '',
    region: undefined
  },

  validationSchema: Yup.object({
    projectId: Yup.string().trim().required(),
    projectToken: Yup.string().trim().required(),
    serviceAccountUsername: Yup.string().trim().required(),
    serviceAccountSecret: Yup.string().trim().required(),
    region: Yup.string().trim().nullable()
  }),
};
